import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import { MeasurementGraphProps } from './MeasurementGraph.types';

function MeasurementGraph({ alignment }: MeasurementGraphProps) {
  return (
    <Box
      position="absolute"
      justifyContent="space-between"
      pointerEvents="none"
      width="100%"
      height="100%"
      alignItems={alignment === 'left' ? 'flex-start' : 'flex-end'}
    >
      {Array.from({ length: 9 }, (_, index) => (
        <Box
          key={index}
          variant="outline-gradient"
          gradient={
            alignment === 'left' ? 'borderGraphInversed' : 'borderGraph'
          }
          width={index === 0 ? 27 : 8}
          opacity={Number(index !== 8)}
          height={1}
        />
      ))}
    </Box>
  );
}

export default memo(MeasurementGraph);
